import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

import { getDictionaryItem } from '_utils/data/dictionaryItem';

import { ContactDetailsFormProps } from '../definitions';

import { Container, FormContainer, NarrowContainer } from '_utils/components/Form/StyledContainerForm';
import { EditModeHeading, EditModeInstructions, FormSection, LargeHeading, RichTextContainer } from '_utils/components/Form/StyledFormSection';

const EditMode: React.FC<ContactDetailsFormProps> = (props) => {
  const rendering = props?.rendering;
  const apiErrorheading = getDictionaryItem('form-api-error-heading', 'We’re experiencing some technical difficulties');

  return (
    <Container>
      <FormContainer>
        <NarrowContainer>
          <EditModeHeading>Contact Details Form</EditModeHeading>
          <EditModeInstructions>
            Given this component relies on member data and has multiple states, a custom editing experience has been setup to allow you to add content to the placeholders
          </EditModeInstructions>
          <EditModeInstructions>
            <strong>How do I update my name content: </strong> shown below the Personal Details form
            (the intention is to use an Accordion component for this section)
          </EditModeInstructions>
          <FormSection>
            <RichTextContainer>
              <Placeholder name="jss-form-section-help" rendering={rendering} />
            </RichTextContainer>
          </FormSection>
          <EditModeInstructions>
            <strong>API Error Content: </strong> shown below the error message when the APIs returns an error getting data from the ContactProfile API
            (the heading is a dictionary item at <code>/sitecore/content/CPA/Corporate/Dictionary/Forms/API Error Heading</code>)
          </EditModeInstructions>
          <FormSection>
            <LargeHeading>{apiErrorheading}</LargeHeading>
            <RichTextContainer>
              <Placeholder name="jss-form-api-error" rendering={rendering} />
            </RichTextContainer>
          </FormSection>
        </NarrowContainer>
      </FormContainer>
    </Container>
  );
};

export default EditMode;
